<script lang="ts" setup>
  import { ElCheckbox, ElCheckboxButton, ElCheckboxGroup } from 'element-plus';
  import { computed, inject, onMounted, ref, watch } from 'vue';
  import { DICT_STORE, excludeObjectKeys } from '../../../utils';
  import { CheckboxEmits, CheckboxProps, excludeCheckboxKeys } from './checkbox';

  defineOptions({
    name: 'ICheckbox',
  });
  const props = defineProps(CheckboxProps);
  const emit = defineEmits(CheckboxEmits);
  const dictStore = inject(DICT_STORE);
  const bindAttrs = computed(() => excludeObjectKeys(props, excludeCheckboxKeys));

  const checkboxOptions = ref<any[]>([]);
  onMounted(() => setOptions());
  watch(
    () => props.data,
    () => setOptions(),
    { deep: true },
  );
  async function setOptions() {
    const list = await getList();
    checkboxOptions.value = props.dataCallback ? props.dataCallback(list) : list;
  }

  async function getList() {
    if (Array.isArray(props.data)) {
      return props.data;
    }
    if (dictStore) {
      return await dictStore.getDict(props.data);
    }
    return [];
  }

  const value = ref('');
  watch(
    () => props.modelValue,
    (val: any) => (value.value = val),
    { deep: true, immediate: true },
  );
  const handleChange = (val: any) => {
    emit('change', val);
    emit('update:modelValue', val);
  };
</script>

<template>
  <ElCheckboxGroup v-model="value" v-bind="bindAttrs" @change="handleChange">
    <template v-if="type === 'button'">
      <ElCheckboxButton
        v-for="item of checkboxOptions"
        :key="item[optValue]"
        :label="item[optValue]"
        :disabled="item.disabled"
      >
        {{ item[optLabel] }}
      </ElCheckboxButton>
    </template>
    <template v-else>
      <ElCheckbox
        v-for="item of checkboxOptions"
        :key="item[optValue]"
        :label="item[optValue]"
        :disabled="item.disabled"
        :border="border"
      >
        {{ item[optLabel] }}
      </ElCheckbox>
    </template>
  </ElCheckboxGroup>
</template>
